// extracted by mini-css-extract-plugin
export default {"root":"offer-contracts_root__u5iVE"};